// eslint-disable-next-line import/no-restricted-paths
import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import { useSignOut } from "@/hooks/use-auth-client";

import type { ButtonProps } from "@/components/ui/button/button";
import { Button } from "@/components/ui/button/button";

import { useLoadingScreen } from "../../side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

type Props = {
	className?: string;
	variant?: ButtonProps["variant"];
	size?: ButtonProps["size"];
};

export const AuthSignOutButton = ({ className, variant, size }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { signOut } = useSignOut();
	const apolloClient = useApolloClient();

	const handleClickSignOut = useCallback(async () => {
		showLoadingScreenCallback();
		await apolloClient
			.clearStore()
			.then(() => signOut())
			.finally(() => hideLoadingScreenCallback());
	}, [apolloClient, hideLoadingScreenCallback, showLoadingScreenCallback, signOut]);

	return (
		<Button className={cn(className)} type="button" size={size} variant={variant} onClick={handleClickSignOut}>
			ログアウト
		</Button>
	);
};
